module.exports = __webpack_public_path__ + "static/media/icon-compliance.52058959.svg";